<template>
    <div>
        <VJoyInput v-model="confirmedProjectId" label="Confirmed project id to link to this referral" name="confirmedProjectId" />
        <VJoyButton :loading="loading" @click="linkProject">Link</VJoyButton>
    </div>
</template>

<script setup lang="ts">
    import {ref} from 'vue';
    import {useRoute} from '@typed-router';
    import {VJoyButton, VJoyInput, VJoyWrapper} from '@maltjoy/core-vue';
    import {useReferralsAdminStore} from '~/stores/referrals.admin.store';

    const {params} = useRoute('my-referrals-referralId-projects');

    const loading = ref(false);

    const confirmedProjectId = ref('');

    const {createMissingReferredProjectDeliverable} = useReferralsAdminStore();

    async function linkProject() {
        try {
            loading.value = true;
            await createMissingReferredProjectDeliverable(params.referralId, confirmedProjectId.value);
            window.location.reload();
        } catch (e) {
            console.error(e);
        } finally {
            loading.value = false;
        }
    }
</script>
